import styled from '@emotion/styled';
import { Select } from '@travelnest/merlin.select';
import * as React from 'react';
import { IProperty } from '../../../data/entities/property';

interface IPropertySwitcherProps {
	customerId: string;
	loading: boolean;
	properties: IProperty[];
	currentPropertyId?: string | number;
	switchProperty: (propertyId: string | number) => any;
	sortPropertiesBy?: (current: IProperty, next: IProperty) => number;
}

const Wrapper = styled.div`
	@media screen and (min-width: 768px) {
		max-width: 335px;
	}
`;

export const PropertySwitcher: React.FC<IPropertySwitcherProps> = ({
	customerId,
	switchProperty,
	currentPropertyId,
	loading,
	properties,
	sortPropertiesBy = () => 0
}) => {
	const onSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		switchProperty(e.target.value);
	};

	React.useEffect(() => {
		if (properties.length !== 0 && currentPropertyId === undefined) {
			switchProperty(properties[0].id);
		}
	}, [properties]);

	return <Wrapper>
		<Select onChange={onSelectionChange} id="property-switcher" data-testid="property-switcher">
			{loading
				? <option>Loading...</option>
				: properties.sort(sortPropertiesBy).map((p, i) => {
					const extraProps = p.id.toString() === currentPropertyId ? { selected: true } : {};
					return <option key={i} value={p.id.toString()} {...extraProps}>{p.internal_name}</option>;
				})}
		</Select>
	</Wrapper>;
};
